import React from 'react';

const CorpsSection = (props) => {
    return (
        <>
            <section className="resume-section" id={props.id}>
                <div className="resume-section-content">
                    <h2 className="mb-5">{props.title}</h2>
                    {props.children}
                </div>
            </section>
            <hr className="m-0" />
        </>
    );
};

export default CorpsSection;